import { render, staticRenderFns } from "./floating-view.vue?vue&type=template&id=4e4f5150&scoped=true"
import script from "./floating-view.vue?vue&type=script&lang=js"
export * from "./floating-view.vue?vue&type=script&lang=js"
import style0 from "./floating-view.vue?vue&type=style&index=0&id=4e4f5150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f5150",
  null
  
)

export default component.exports